/**
 * AttorneyStageNav — the attorney Case Workspace navigation chrome: the 7-stage
 * Stage Strip (K3 taxonomy). Unlike the accountant, the attorney has NO Case Profile
 * Bar (claim-type/evidence chips) — that surface is the CPA's forensic-intake concern;
 * the attorney is a downstream legal consumer. Rendered ONLY for role="attorney".
 *
 * The strip informs, it does NOT fence: attorneys navigate non-linearly (K3), so
 * stages carry no completed-chain pip semantics. Per-stage badges (missing-doc count,
 * elected method, N DRAFT, audit state) light up in later batches from real case data.
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { StageStrip, stagesForRole, type StageStripItem } from './stage-strip';

export interface AttorneyStageNavProps {
  /** Base path for stage navigation (e.g. /attorney/case/:caseId) */
  basePath: string;
  /** The currently viewed stage id */
  activeStageId: string;
  className?: string;
}

export function AttorneyStageNav({ basePath, activeStageId, className }: AttorneyStageNavProps) {
  const navigate = useNavigate();

  const stages: StageStripItem[] = stagesForRole('attorney').map((s) => ({
    id: s.id,
    label: s.label,
  }));

  return (
    <div className={className}>
      <StageStrip
        stages={stages}
        activeStageId={activeStageId}
        onNavigate={(id) => navigate(`${basePath}/${id}`)}
      />
    </div>
  );
}

export default AttorneyStageNav;
